import { useEffect } from "react";
import { refreshSession } from "../utility/refresh-token";
import { Spin } from "antd";

function RefreshToken() {
  useEffect(() => {
    console.log("refreshToken comp");
    refreshSession();
  }, []);

  return (
    <div
      style={{
        width: "100vw",
        height: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        gap: "1.5rem",
        flexDirection: "column",
      }}
    >
      {!navigator?.onLine ? (
        <h3>Please Check Your Internet Connection!</h3>
      ) : (
        <>
          <Spin size="large" />
          <h3>Please Wait...</h3>
        </>
      )}
    </div>
  );
}

export default RefreshToken;
